import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import Redirect from '../../components/Redirect'
import useTemplateId from '../../hooks/useTemplateId'
import FeatureLink from 'components/FeatureLink'
import SlideInWrapper from 'components/SlideInWrapper'
import Video from 'components/Video'
import { ArrowsIcon, StackIcon } from 'components/icons'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import AdvancedSettingsLayout from 'layouts/AdvancedSettingsLayout'

const LinksList = styled.ul`
	width: 100%;
	list-style: none;
	padding: 0;
	margin: 0;
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spaces.space5};
`

const EmptyStateContainer = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 32px;
	margin: 0 10%;
`

const VideoWrapper = styled.div`
	width: 100%;
	max-width: 600px;
	border-radius: ${({ theme }) => theme.borderRadiuses.xxl};
	overflow: hidden;
`

const Caption = styled.p`
	${({ theme }) => theme.typography.caption};
	max-width: 320px;
	text-align: center;
	margin: 0;
`

function SiteSettings() {
	useSectionOpenedTracking()
	const { templateId, withTemplateId } = useTemplateId()
	const theme = useTheme()

	if (theme.isMobile) {
		return <Redirect to={withTemplateId('/configurator/widget-content')} />
	}

	return (
		<AdvancedSettingsLayout
			leftColumn={
				<SlideInWrapper axis="y">
					<LinksList>
						<li>
							<FeatureLink href={`/advanced-settings/templates/${templateId}`} icon={<StackIcon />}>
								Templates
							</FeatureLink>
						</li>
						<li>
							<FeatureLink href="/advanced-settings/rules" icon={<ArrowsIcon />}>
								Rules
							</FeatureLink>
						</li>
					</LinksList>
				</SlideInWrapper>
			}
			rightColumn={
				<EmptyStateContainer>
					<VideoWrapper>
						<Video src="/videos/AdvancedSettingsEmptyState.mp4" />
					</VideoWrapper>
					<Caption>
						Create tailored widget <strong>Templates</strong> for different audiences, and use <strong>Rules</strong> to
						control on what pages they appear for a seamless user experience.
					</Caption>
				</EmptyStateContainer>
			}
		/>
	)
}

export default SiteSettings
